import { cn } from 'helpers/classnames';
import ReturnInstructionsBoxes from 'components/account/Returns/ReturnInstructionsBoxes';
import { RETURN_STEPS } from 'constants/returnItemInstructions';
import DropDownArrow from 'images/zappos/dropDownArrow.svg';

import css from 'styles/containers/returns/returnInstructionsSection.scss';

const ReturnInstructionsSection = ({ checked, displayOnly, extraInfo, storeIcon, showInstructions, showInstructionsHandler, value }) => {
  const isInstructionExpanded = showInstructions === value;
  const showToggleButton = checked && !displayOnly;
  const showInstructionBox = isInstructionExpanded || displayOnly;
  return (
    <>
      <div
        className={cn(css.instructionsContainerMobile, {
          [css.instructionsContainerMobileDisplayOnly]: displayOnly,
          [css.instructionOpen]: showInstructionBox
        })}
      >
        {showToggleButton && (
          <button className={css.toggleInstructionsButton} onClick={showInstructionsHandler} type="button" value={value}>
            {isInstructionExpanded ? 'Hide Instructions' : 'Show Instructions'}
            <img className={cn({ [css.hideInstructionsArrow]: isInstructionExpanded })} src={DropDownArrow} alt={'dropDownArrow'} />
          </button>
        )}

        {showInstructionBox && (
          <div className={css.displayOnlyInstructionBoxes}>
            <ReturnInstructionsBoxes steps={RETURN_STEPS[value].newBoxes} />
            {extraInfo}
          </div>
        )}

        {showToggleButton && (
          <img src={storeIcon} alt="storeIcon" className={cn(css.instructionStoreIcon, { [css.instructionStoreIconOpen]: showInstructions })} />
        )}
      </div>
      <div className={css.instructionsContainerDesktop}>
        {checked && (
          <div className={cn(css.instructionBoxes, { [css.displayOnlyInstructionBoxes]: displayOnly })}>
            <ReturnInstructionsBoxes steps={RETURN_STEPS[value].newBoxes} />
            {extraInfo}
          </div>
        )}
      </div>
    </>
  );
};

export default ReturnInstructionsSection;
